import { render, staticRenderFns } from "./SurveyDuplicateDialog.vue?vue&type=template&id=0018f6ee&scoped=true"
import script from "./SurveyDuplicateDialog.vue?vue&type=script&lang=js"
export * from "./SurveyDuplicateDialog.vue?vue&type=script&lang=js"
import style0 from "./SurveyDuplicateDialog.vue?vue&type=style&index=0&id=0018f6ee&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0018f6ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0018f6ee')) {
      api.createRecord('0018f6ee', component.options)
    } else {
      api.reload('0018f6ee', component.options)
    }
    module.hot.accept("./SurveyDuplicateDialog.vue?vue&type=template&id=0018f6ee&scoped=true", function () {
      api.rerender('0018f6ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/Edit/SurveyDuplicateDialog.vue"
export default component.exports